// Clear Data

export default (data, value, clear) => {
  value = new Object(value)
  Object.keys(data).forEach(key => {
    value[key] = clear ? null : ['select', 'image'].indexOf(data[key].type) > -1 ? data[key].value.value : data[key].value
  })
  return value
}
